import { graphql } from "gql";

const MESSAGE_PROFILE_QUERY = graphql(`
  query MessageProfile($id: ID!) {
    messages(id: [$id]) {
      ...MessageProfile
    }
  }
`);

export default MESSAGE_PROFILE_QUERY;
